import React, { useEffect } from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { useUserStats } from './@hooks'
import { clearUserStatsSignals } from './@signals'
import Filters from './Filters'
import SummaryCards from './SummaryCards'
import Table from './Table'
import UserDetailDrawer from './UserDetailDrawer'

export default function UserStatsPage() {
    useUserStats()

    useEffect(() => {
        return clearUserStatsSignals
    }, [])

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    User Stats
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Review user mapping activity and productivity
                </Typography>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Filters />
                </Grid>
                <Grid item xs={12}>
                    <SummaryCards />
                </Grid>
                <Grid item xs={12}>
                    <Table />
                </Grid>
            </Grid>
            <UserDetailDrawer />
        </Box>
    )
}
